import styled, { css } from 'styled-components';
import { Small } from '@finect/tabular-core/Small';
import { getFont } from '@finect/tabular-utils/getFont';
export var DistributorsFiltersContent = styled.div.withConfig({
  displayName: "partials__DistributorsFiltersContent",
  componentId: "sc-pksf3h-0"
})(["display:flex;align-items:center;padding:12px 0;"]);
export var DistributorsContent = styled.ul.withConfig({
  displayName: "partials__DistributorsContent",
  componentId: "sc-pksf3h-1"
})(["display:flex;align-items:center;margin-left:8px;> span svg{cursor:pointer;}"]);
export var IconContent = styled.span.withConfig({
  displayName: "partials__IconContent",
  componentId: "sc-pksf3h-2"
})(["", " ", ""], function (_ref) {
  var isActive = _ref.isActive,
    filterActive = _ref.filterActive;
  return filterActive && !isActive && css(["img{opacity:0.2;}"]);
}, function (_ref2) {
  var isActive = _ref2.isActive,
    filterActive = _ref2.filterActive;
  return filterActive && isActive && css(["img{border:1px solid ", ";border-radius:", ";box-shadow:", ";}"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.terciaryL;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.borderRadius;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.boxShadow;
  });
});
export var Distributor = styled.li.withConfig({
  displayName: "partials__Distributor",
  componentId: "sc-pksf3h-3"
})(["display:inline-block;cursor:pointer;"]);
export var QtyTip = styled(Small).withConfig({
  displayName: "partials__QtyTip",
  componentId: "sc-pksf3h-4"
})(["", ";"], getFont(-2, 'compact'));